<template>
  <div class="map">
    <div class="gmap" v-bind:class="{ en: this.$route.params.lang === 'en' }"></div>
  </div>
</template>

<style lang="less">
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
  @screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  .screen-xs(@rules) {
      @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
      @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
      @media (max-width: @screen-lg-max) { @rules(); }
  }

  .map {
    margin: 100px auto;
    .screen-xs({
        margin: 30px auto 50px;
      });
    .gmap {
      width: 100%;
      height: 700px;
      margin:0 auto;
      .screen-sm({
        height: 550px;
      });
      .screen-xs({
        margin: 0 -6%;
        width: 112%;
        height: 350px;
      });
      .gm-style-iw{
        div{
          div{
            width: 300px;
            .screen-sm({
              width: 150px;
            });
            a{
              color: #000;
            }
            a,
            span{
              p:first-child{
                font-size: 16px;
                font-weight: bold;
              }
              img{
                max-height: 20vh;
                .screen-sm({
                  width: 100%;
                });
              }
              p:last-child{
                font-size: 14px;
                text-align: left;
                span{
                  display: block;
                  font-size: 12px;
                  text-align: center;
                }
              }
            }
          }
        }
      }
      .gm-ui-hover-effect{
        img{
          width: 35px !important;
          height: 35px !important;
          margin: 5px -10px !important;
          .screen-sm({
            width: 25px !important;
            height: 25px !important;
            margin: 0 !important;
          });
        }
      }
    }
    .gmap.en{
      .gm-style-iw{
        div{
          div{
            a,
            span{
              p:first-child{
                width: 100%;
              }
              p:last-child{
                display: none;
              }
            }
          }
        }
      }
    }
  }
</style>

<script>
  import $ from "jquery"

  export default {
    name: 'Map',
    props: {
      options:Object,
      points:Array
    },
    data: function() {
      return {
        mapName:'.gmap',        // マップ適用先
        map:null,               // マップオブジェクト
        markers:[],             // マーカー保存用
        currentInfoWindow:null, // 表示中のポップアップ
        mapBounds:null          // マップ制限範囲
      }
    },
    mounted() {
      this.initMap()
    },
    updated() {
      this.reInitMap()
    },
    methods: {
      // マップ初期化
      initMap() {
        // デフォルトのマーカーを非表示にする
        //this.disableInfoWindow()
        this.createMap()
        this.reInitMap()
        // this.registerMapBoundsBehavior()
      },
      // マップ再初期化
      reInitMap() {
        this.setMapOptions()
        this.setMapBounds()
        this.setMapMarkers()
      },
      // マップ作成
      createMap() {
        const self = this
        const elem = $(this.mapName)[0]
        this.map = new google.maps.Map(elem, {
          //trueにするとコントローラーが全部消える
          disableDefaultUI:false,
          //マップタイプ切り替えの表示
          mapTypeControl: true,
          /*
          // 企業系のマーカー非表示用
          styles: [{
            featureType: 'poi.business',
            stylers: [
              { visibility: 'off' }
            ]
          }]
          */
        })
        
        google.maps.event.addListener(this.map, 'click', (event) => {
          //conso position = event.latLng
          //console.log(position.lat() + " : " + position.lng())
          // マップクリック時に作成したマーカーから表示したポップアップを閉じる
          // 既存のグーグルマップが表示するマーカーからのポップアップには効果なし
          //self.closeInfoWindow()
        })
      },
      // マップ移動範囲制限処理
      // registerMapBoundsBehavior() {
      //   const self = this
      //   google.maps.event.addListener(this.map, 'dragend', function() {
      //     if (!self.mapBounds || self.mapBounds.contains(self.map.getCenter())) {
      //       return
      //     }
      //     // We're out of bounds - Move the map back within the bounds
      //     const c = self.map.getCenter()
      //     let x = c.lng()
      //     let y = c.lat()
      //     const maxX = self.mapBounds.getNorthEast().lng()
      //     const maxY = self.mapBounds.getNorthEast().lat()
      //     const minX = self.mapBounds.getSouthWest().lng()
      //     const minY = self.mapBounds.getSouthWest().lat()

      //     if (x < minX) {x = minX}
      //     if (x > maxX) {x = maxX}
      //     if (y < minY) {y = minY}
      //     if (y > maxY) {y = maxY}

      //     self.map.setCenter(new google.maps.LatLng(y, x))
      //   });
      // },
      // マップオプションセット
      setMapOptions() {
        const center_lat = Number(this.options.center_lat)
        const center_lng = Number(this.options.center_lng)
        const zoom = Number(this.options.zoom)
        const options = {
          center: {lat:center_lat, lng: center_lng},
          zoom: zoom,
          mapTypeControl: false,
          streetViewControl: false,
        }
        this.map.setOptions(options)
      },
      // マップ範囲セット
      setMapBounds() {
        if (Number(this.options.sw_lat) && Number(this.options.sw_lng) && Number(this.options.ne_lat) && Number(this.options.ne_lng)) {
          this.mapBounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(Number(this.options.sw_lat), Number(this.options.sw_lng)),
            new google.maps.LatLng(Number(this.options.ne_lat), Number(this.options.ne_lng))
          )
        }
        else {
          this.mapBounds = null
        }
      },
      // マーカーセット
      setMapMarkers() {
        const self = this
        
        this.clearMarkers()
        
        if (this.points) {
          for (let i=0; i<this.points.length; ++i) {
            const m = this.points[i]
            const lat = Number(m.lat)
            const lng = Number(m.lng)
            const minitext = m.minitext
            const detailtext = m.text
            const title = m.title
            const ruby = m.ruby
            const thumbnail = m.thumbnail
            const url = `${location.href}`.replace(/\?.*$/,"") + `/${m.id}`;

            let content = ""
            const imgurl = ""
            if (this.hasDetail(m)) {
              // 詳細説明がある場合はリンクあり
              content = `<a class="marker" target="_blank" href="${url}"><p>${title}</p><br class="sp_block"><img src="${thumbnail}"><p>${minitext}</p></a>`
              imgurl = 'image/marker_destination_0.png' /*リンクありのマップピン*/
            }
            else {
              // 詳細説明が無い場合はリンクなし
              content = `<span class="marker"><p>${title}</p><br class="sp_block"><img src="${thumbnail}"><p>${minitext}</p></span>`
              imgurl = 'image/marker_arrival_0.png' /*リンクなしのマップピン*/
            }
            
            const marker = new google.maps.Marker({
              position: {lat:lat, lng:lng},
              map: this.map,
              icon: imgurl
            })
            this.markers.push(marker)
            
            const infowindow = new google.maps.InfoWindow({
              noSuppress:true, // InfoWindow無効化時でも表示するためのフラグ
              content: content
            })
            marker.addListener('click', function() {
              self.closeInfoWindow()
              infowindow.open(self.map, marker)
              self.currentInfoWindow = infowindow
            })
          }
        }
      },
      // マーカー削除
      clearMarkers() {
        this.closeInfoWindow()
        for (let i = 0; i < this.markers.length; ++i) {
          this.markers[i].setMap(null)
        }
        this.markers = []
      },
      // ポップアップを閉じる
      closeInfoWindow() {
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close()
          this.currentInfoWindow = null
        }
      },
      // InfoWindow無効化
      // https://scientre.hateblo.jp/entry/20140410/disable_poi_popup
      // https://stackoverflow.com/questions/7950030/can-i-remove-just-the-popup-bubbles-of-pois-in-google-maps-api-v3/19710396#19710396
      disableInfoWindow() {
        const set = google.maps.InfoWindow.prototype.set
        google.maps.InfoWindow.prototype.set = function(key, val) {
          if (key === "map") {
            if (! this.get("noSuppress")) {
              return
            }
          }
          set.apply(this, arguments)
        }
      },
      hasDetail(point) {
        if (point.text && (point.text.length > 0)) {
          return true
        }
        return false
      },
    }
  }
</script>